import React from 'react'
import { ContextNotification } from '@pandiafi/components'

import {
  ContractType,
  TerminationDisallowedReason,
} from '../../../../../common/types'

import { useTerminationDisallowedReason } from 'views/ContractChanges/hooks/useTerminationDisallowedReason'

interface terminationDisallowedBannerProps {
  reason: TerminationDisallowedReason | undefined
  contractType: ContractType
}

export const TerminationDisallowedBanner: React.FC<
  terminationDisallowedBannerProps
> = ({ reason, contractType }) => {
  const { terminationDisallowedReason } = useTerminationDisallowedReason(
    reason,
    contractType
  )

  if (!terminationDisallowedReason) {
    return null
  }

  return (
    <ContextNotification textAlign="center" className="mb-6">
      {terminationDisallowedReason}
    </ContextNotification>
  )
}
